import { Routes } from 'lemans-brandsites-common/components/Routes/Routes.component';
import * as React from 'react';
import './Content.styles.less';
import { IContentProps } from "./Content.types";

export const Content = (props:IContentProps) =>
    <div className="Content">
        <Routes />
    </div>;
